import { AjaxHelper } from './AjaxHelper';

export async function loadPaypalScripts() {
  const clientId = await AjaxHelper.get<string>('/PaypalClient');

  // Add in the paypal client script tags
  const script = document.createElement('script');
  script.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${clientId}`);
  document.body.appendChild(script);
}